import { getAccountDetails, updateAccountDetails, getAccountInvites, inviteAccountUser, deleteInvite, inviteTenantToDeal, savePrivateFiles } from "../../platform/account/repositories/accountRepository"
import { getField, updateField } from 'vuex-map-fields';

const initialStateAccount = Object.freeze({
    accountInitiated: true,
    accountDetails: {
        accountId: "",
        accountName: "",
        paymentDetails: {
            accountHolderName: "",
            bankName: "",
            swiftCode: "",
            ibanCode: ""
        },
        contactDetails: {
            contactEmail: "",
            contactPhone: ""
        }
    },
    loadingAccount: true,
    loadingAccountErr: "",
    savingAccountErr: ""
});

export default {
    state: {
        accountInitiated: true,
        accountDetails: {
            accountId: "",
            accountName: "",
            paymentDetails: {
                accountHolderName: "",
                bankName: "",
                swiftCode: "",
                ibanCode: ""
            },
            contactDetails: {
                contactEmail: "",
                contactPhone: ""
            }
        },
        loadingAccount: true,
        loadingAccountErr: "",
        savingAccountErr: "",
        loadingAccountInvites: false,
        accountInvities: {
            accountId: "",
            invites: []
        },
        loadingAccountInvitesErr: "",
        invitationLoading: "",
        invitationFailed: "",
        userRoleInAccount: "",
        accountReadRoles: ["admin", "default", "manager", "accountant", "viewer"],
        accountWriteRoles: ["admin", "default", "manager"],
        dealNoteWriteRoles: ["admin", "default", "manager", "accountant"],
    },
    getters: {
        accountReadRoles: state => state.accountReadRoles,
        accountWriteRoles: state => state.accountWriteRoles,
        dealNoteWriteRoles: state => state.dealNoteWriteRoles,
        accountInitiated: state => state.accountInitiated,
        getAccountDetails(state) {
            return getField(state.accountDetails);
        },
        getAccountPaymentDetails(state) {
            return getField(state.accountDetails.paymentDetails);
        },
        getAccountContactDetails(state) {
            return getField(state.accountDetails.contactDetails);
        },
        userRoleInAccount: state => state.userRoleInAccount,
        loadingAccount: state => state.loadingAccount,
        loadingAccountErr: state => state.loadingAccountErr,
        loadingAccountInvites: state => state.loadingAccountInvites,
        loadingAccountInvitesErr: state => state.loadingAccountInvitesErr,
        accountDetails: state => state.accountDetails,
        accountInvities: state => state.accountInvities,
        accountName: state => state.accountDetails.accountName,
        invitationLoading: state => state.invitationLoading,
        invitationFailed: state => state.invitationFailed,
        accountPaymentDetails: state => { return state.accountDetails.paymentDetails },
        accountContactDetails: state => { return state.accountDetails.contactDetails }
    },
    mutations: {
        SET_ACCOUNT_INITIATED(state, payload) {
            state.accountInitiated = payload;
        },
        updateAccountDetails(state, field) {
            updateField(state.accountDetails, field);
        },
        updateAccountPaymentDetails(state, field) {
            updateField(state.accountDetails.paymentDetails, field);
        },
        updateAccountContactDetails(state, field) {
            updateField(state.accountDetails.contactDetails, field);
        },
        ADD_TO_ACCOUNT_INVITES(state, payload) {
            state.accountInvities.invites.push(payload);
        },
        REMOVE_FROM_ACCOUNT_INVITES(state, inviteId) {
            for (var i = 0, n = state.accountInvities.invites.length; i < n; i++) {
                if (state.accountInvities.invites[i].id == inviteId) state.accountInvities.invites.splice(i, 1);
            }
        },
        REMOVE_LAST_INVITE(state) {
            var i = state.accountInvities.invites.length - 1
            if (i >= 0) state.accountInvities.invites.splice(i, 1);
        },
        RESET_ACCOUNT_DETAILS(state) {
            Object.keys(initialStateAccount).forEach(key => {
                state[key] = initialStateAccount[key]
            });
        },
        SET_USER_ACCOUNT_CONNECTION(state, payload) {
            state.userRoleInAccount = payload
        },
        SET_ACCOUNT_DETAILS(state, payload) {
            if (payload.accountId) Vue.set(state.accountDetails, "accountId", payload.accountId);
            if (payload.name) Vue.set(state.accountDetails, "accountName", payload.name);
            if (payload.paymentDetails) Vue.set(state.accountDetails, "paymentDetails", payload.paymentDetails);
            if (payload.contactDetails){
                // Enforce contactDetails to always have email and phone in order to guarantee reactivity in components.
                if(!payload.contactDetails.contactPhone) payload.contactDetails.contactPhone = ""
                if(!payload.contactDetails.contactEmail) payload.contactDetails.contactEmail = ""
                Vue.set(state.accountDetails, "contactDetails", payload.contactDetails);
            } 
        },
        SET_ACCOUNT_INVITES(state, { accountId, invites }) {
            Vue.set(state.accountInvities, "accountId", accountId);
            Vue.set(state.accountInvities, "invites", invites);
        },
        CLEAR_ACCOUNT_INVITES(state) {
            Vue.set(state.accountInvities, "accountId", "");
            Vue.set(state.accountInvities, "invites", []);
        },
        SET_LOADING_ACCOUNT(state, payload) {
            state.loadingAccount = payload;
        },
        SET_LOADING_ACCOUNT_INVITES(state, payload) {
            state.loadingAccountInvites = payload;
        },
        SET_LOADING_ACCOUNT_ERR(state, payload) {
            state.loadingAccountErr = payload;
        },
        SET_LOADING_ACCOUNT_INVITES_ERR(state, payload) {
            state.loadingAccountInvitesErr = payload;
        },
        SET_SAVING_ACCOUNT_ERR(state, payload) {
            state.savingAccountErr = payload;
        },
        SET_INVITE_ACCOUNT_LOADING(state, payload) {
            state.invitationLoading = payload;
        },
        SET_INVITE_ACCOUNT_ERR(state, payload) {
            state.invitationFailed = payload
        }
    },
    actions: {
        async updateAccount(store, { accountId, updates }) {
            store.commit("SET_SAVING_ACCOUNT_ERR", "")
            updateAccountDetails(accountId, updates)
                .then(response => {
                    store.commit("SET_ACCOUNT_DETAILS", response)
                })
                .catch(err => {
                    console.log('account store err:', err);
                    store.commit("SET_SAVING_ACCOUNT_ERR", "Cannot save account")
                })
                .finally(f => {
                })
        },
        async getAccount(store, accountId) {
            if (store.getters.accountDetails.name && store.getters.accountDetails.accountId == accountId) {
                return (store.getters.accountDetails)
            }
            else {
                try {
                    store.commit("SET_LOADING_ACCOUNT", true)
                    store.commit("SET_LOADING_ACCOUNT_ERR", "")
                    var account = await getAccountDetails(accountId)
                    
                    store.commit("SET_ACCOUNT_DETAILS", account.accountDetails)
                    if (account.userAccountConnection) {
                        var role = account.userAccountConnection.connection
                        if (role == "default") role = "admin"
                        store.commit("SET_USER_ACCOUNT_CONNECTION", role)
                    } else {
                        store.commit("SET_USER_ACCOUNT_CONNECTION", "unknown")
                    }

                } catch (error) {
                    store.commit("SET_LOADING_ACCOUNT_ERR", "Cannot get account")
                } finally {
                    store.commit("SET_LOADING_ACCOUNT", false)
                    return store.getters.accountDetails
                }
            }
        },
        async getAccountInvites(store, { accountId, refresh }) {
            if (refresh) store.commit("CLEAR_ACCOUNT_INVITES")
            if (store.getters.accountInvities && store.getters.accountInvities.accountId == accountId) {
                return (store.getters.accountInvities.invites)
            } else {
                try {
                    store.commit("SET_LOADING_ACCOUNT_INVITES", true)
                    store.commit("SET_LOADING_ACCOUNT_INVITES_ERR", "")
                    var invites = await getAccountInvites(accountId)
                    store.commit("SET_ACCOUNT_INVITES", { accountId, invites })
                } catch (error) {
                    store.commit("SET_LOADING_ACCOUNT_INVITES_ERR", "Cannot get invitations")
                } finally {
                    store.commit("SET_LOADING_ACCOUNT_INVITES", false)
                    return store.getters.accountInvities.invites
                }
            }
        },
        async inviteAccountUser(store, { accountId, inviterUid, invitorName, inviteeEmail, role }) {
            if (store.getters.accountInvities && store.getters.accountInvities.accountId == accountId) {
                for (var i = 0, n = store.getters.accountInvities.invites.length; i < n; i++) {
                    if (store.getters.accountInvities.invites[i].email == inviteeEmail && store.getters.accountInvities.invites[i].status == 'pending') {
                        return
                    };
                }
            }
            try {
                store.commit("SET_INVITE_ACCOUNT_LOADING", true)
                store.commit("SET_INVITE_ACCOUNT_ERR", "")
                store.commit("ADD_TO_ACCOUNT_INVITES", { loading: true })
                var invite = await inviteAccountUser({ accountId, inviterUid, invitorName, inviteeEmail, role });
                store.commit("REMOVE_LAST_INVITE")
                store.commit("ADD_TO_ACCOUNT_INVITES", invite)
            } catch (error) {
                store.commit("SET_INVITE_ACCOUNT_ERR", "Cannot invite")
                store.commit("REMOVE_FROM_ACCOUNT_INVITES", invite.id)
            } finally {
                store.commit("SET_INVITE_ACCOUNT_LOADING", false)
                return
            }
        },
        async revokeInvitation(store, { accountId, inviteId }) {
            try {
                store.commit("REMOVE_FROM_ACCOUNT_INVITES", inviteId)
                await deleteInvite({ inviteId, accountId });
            } catch (error) {
                store.commit("SET_INVITE_ACCOUNT_ERR", "Cannot remove")
            } finally {
                return
            }
        },
        async inviteTenantToDeal(store, { inviterUid, dealId, tenantAltEmail, accountId, inviteeName }) {

            try {
                var invite = await inviteTenantToDeal({ inviterUid, dealId, tenantAltEmail, accountId, inviteeName })
                console.log("inviteTenantToDeal > done")
            } catch (error) {
            } finally {
                return
            }
        },
        async savePrivateFiles({ commit }, { accountId, fileNames }) {
            try {
                commit('SET_LOADING_ACCOUNT', true);
                await savePrivateFiles(accountId, fileNames);
                commit('SET_PRIVATE_PERSONS_FILES', fileNames);
            }
            catch (error) {
                // propagate error to the calling component...
                throw error;
            }
            finally {
                commit('SET_LOADING_ACCOUNT', false);
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/vuex/account/index.js